import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Api from "services/api"


export const initialState = {
  allInterpreters: [],
  remainingInterpreters: [],
  interpretersWithAppointments: [],
  invitedInterpreters: [],
  inviteInterpreters: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  dynamicFields: [

  ],
  analytics: [],
  appointment: []
}

export const inviteInterpretersSlice = createSlice({
  name: 'inviteInterpreters',
  initialState: initialState,
  reducers: {
  setInviteInterpreter: (state, { payload }) => {
    state.inviteInterpreters = payload?.data ?? payload ?? [];
    state.total = payload?.total ?? 0;
    state.is_more = payload?.is_more ?? false;
    state.last_page = payload?.last_page ?? 1;
  },

  setInviteInterpreters: (state, { payload }) => {
    state.inviteInterpreters = payload?.data ?? payload ?? [];
    state.total = payload?.total ?? 0;
    state.is_more = payload?.is_more ?? false;
    state.last_page = payload?.last_page ?? 1;
  },

  setAllInterpreters: (state, { payload }) => {
    state.allInterpreters = Array.isArray(payload) ? payload : payload?.data ?? [];
  },

  setRemainingInterpreters: (state, { payload }) => {
    state.remainingInterpreters = Array.isArray(payload) ? payload : payload?.data ?? [];
  },

  setAppointment: (state, { payload }) => {
    state.appointment = payload?.data?.invites ?? [];
  },

  setInterpretersWithAppointments: (state, { payload }) => {
    state.interpretersWithAppointments = Array.isArray(payload) ? payload : payload?.data ?? [];
  },

  setInvitedInterpreters: (state, { payload }) => {
    state.invitedInterpreters = Array.isArray(payload) ? payload : payload?.data ?? [];
  },

  setDynamicFields: (state, { payload }) => {
    state.dynamicFields = Array.isArray(payload) ? payload : payload?.data ?? [];
  },

  setMoreInviteInterpreters: (state, { payload }) => {
    const data = Array.isArray(payload?.data) ? payload.data : [];
    state.inviteInterpreters = state.inviteInterpreters.concat(data);
    state.total = payload?.total ?? state.total;
    state.is_more = payload?.is_more ?? state.is_more;
    state.last_page = payload?.last_page ?? state.last_page;
  },

  setError: (state, { payload }) => {
    state.error = payload ?? null;
  },

  setLoader: (state, { payload }) => {
    state.loader = !!payload;
  },

  clearAllInviteInterpreter: (state) => {
    state.allInterpreters = [];
    state.remainingInterpreters = [];
    state.inviteInterpreters = [];
    state.invitedInterpreters = [];
    state.interpretersWithAppointments = [];
    state.error = null;
    state.loader = false;
    state.total = 0;
    state.is_more = false;
    state.last_page = 1;
  },
}

})

export const addInviteInterpreter = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.addInviteInterpreter(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setInviteInterpreter(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const updateInviteInterpreter = (data, itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.updateInviteInterpreter(data, itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setInviteInterpreter(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeInviteInterpreter = (itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeInviteInterpreter(itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setInviteInterpreter(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const fetchInviteInterpreters = (page, params, disableLoader) => async (dispatch) => {
  const apiService = new Api();
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchInviteInterpreters(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        dispatch(setInviteInterpreters(result.data.data));
      } else {
        dispatch(setInviteInterpreters(result.data.data));
      }
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader && dispatch(setLoader(false))
}
export const fetchAppointmentsInterpreters = (id) => async (dispatch) => {
  const apiService = new Api();
  try {

    const result = await Api.fetchAppointmentsInterpreters(id)
    if (result.status >= 200 && result.status < 300) {
      dispatch(setAllInterpreters(result.data));
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
}
export const fetchRemainingInterpreters = (id) => async (dispatch) => {
  try {
    const result = await Api.fetchRemainingInterpreters(id)
    if (result.status >= 200 && result.status < 300) {
      dispatch(setRemainingInterpreters(result.data));
    }
  } catch (error) {
    console.log("error", error)
  }
}

export const fetchInterpretersWithAppointments = (id) => async (dispatch) => {
  const apiService = new Api();
  try {

    const result = await Api.fetchInterpretersWithAppointments(id)
    if (result.status >= 200 && result.status < 300) {
      dispatch(setInterpretersWithAppointments(result.data));
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
}
export const fetchInvitedInterpreters  = (id) => async (dispatch) => {
  const apiService = new Api();
  try {

    const result = await Api.fetchInvitedInterpreters(id)
    if (result.status >= 200 && result.status < 300) {
      dispatch(setInvitedInterpreters(result.data));
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
}

export const removeInvitedInterpreters = (ids, itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeInvitedInterpreters(itemId, ids)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setHospital(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
};
export const addInviteInterpreters = (ids, itemId, callback) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.inviteInterpreters(itemId, ids);
    if (json.status >= 200 && json.status < 300) {
      const updated = await Api.fetchAppointmentsInterpreters(itemId);
      dispatch(setAllInterpreters(updated.data || []));
      const remaining = await Api.fetchRemainingInterpreters(itemId);
      dispatch(setRemainingInterpreters(remaining.data || []));
      callback(true, json.data.message);
    } else if (json.status == 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
    callback(false);
  }
  dispatch(setLoader(false));
};



export const fetchAppointmentView = (id) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {
    const result = await Api.fetchClientAppointmentView(id)
    if (result.status >= 200 && result.status < 300) {
      dispatch(setAppointment(result?.data))
      dispatch(setLoader(false))
    } else if (result?.status == 422) {
      dispatch(setError(result.data))
      dispatch(setLoader(false))
      // callback&&callback(false, result?.data?.message)
    }
  } catch (error) {
    console.log("error", error)
    dispatch(setLoader(false))
    // callback&&callback(false, error?.data?.message)
  }

}

export const { setInviteInterpreter, setInterpretersWithAppointments, setInviteInterpreters, setAllInterpreters, setRemainingInterpreters, clearAllInviteInterpreter, setLoader, setError, setMoreInviteInterpreters, setDynamicFields, setAppointment, setInvitedInterpreters } = inviteInterpretersSlice.actions


export default inviteInterpretersSlice.reducer
export const inviteInterpretersSelector = state => state.inviteInterpreters


